export default __webpack_public_path__ + "static/media/MenuIcon.e4926451.png";